import { Modal } from "@king-ict/eupisi-ui/components";
import { Typography } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useAppDispatch } from "../../../app/store";
import Request from "../../../models/Request/Request";
import RequestStatusEnum from "../../../models/Request/RequestStatusEnum";
import RequestTypeEnum from "../../../models/Request/RequestTypeEnum";
import { childrenList } from "../../../routes/routes";
import { resetIsEdited } from "../../../slices/applicationSlice";

interface IProps {
  request: Request;
  isOpen: boolean;
  onModalClose: () => void;
  code: number | null;
}

export const FinalConfirmModal = ({
  isOpen,
  onModalClose,
  request,
  code,
}: IProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleFinalConfirm = () => {
    onModalClose();
    dispatch(resetIsEdited());

    // To allow the state to be updated in Redux before navigating
    setTimeout(() => {
      history.push(childrenList());
    }, 0);
  };

  const getFinalConfirmMessage = (code: number | null) => {
    if (
      request.type === RequestTypeEnum.EarlyEnrollment &&
      request.statusId !== RequestStatusEnum.OnSchoolCandidateList
    ) {
      return (
        <Typography component="p" variant="medium">
          {t("request.EarlyEnrollmentConfirmModal")}
        </Typography>
      );
    }

    return (
      <Typography component="p" variant="medium">
        {t("request.ConfirmModal_1")}{" "}
        <Typography variant="mediumBold" component="span">
          {code}
        </Typography>
        {t("request.ConfirmModal_2")}
      </Typography>
    );
  };

  return (
    <Modal
      type={"message"}
      title={t("request.ConfirmModalTitle")}
      open={isOpen}
      confirmText={t("common.approve")}
      onConfirm={handleFinalConfirm}
      onClose={handleFinalConfirm}
    >
      <div className="mb-3">{getFinalConfirmMessage(code)}</div>
    </Modal>
  );
};
